import { Box, Typography } from '@mui/material';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import DashboardEmissionsTable from '../../../shared-components/DashboardEmissionsTable'
import { useDispatch, useSelector } from 'react-redux';
import { scopeThreeEmissionColumns, scopeThreeTitle } from '../../../constants/dashboard-constants';
import { useEffect } from 'react';
import { getGroupEmissionsScopeThree } from '../../../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors';


export default function ScopeThreeEmissionsFacilities({ openAccordion, changeAccordion, companyId, groupId, year }) {
    const dispatch = useDispatch()
    const accordionName = 'Scope Three Emissions Facility'
    const groups = useSelector(state => state.carbonFootprintBase.groups);
    const { group } = groups.data.find((group) => (groupId === group._id))
    const columns = scopeThreeEmissionColumns(group)
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.groupScopeThreeLoading))
    const scopeThreeEmissionRows = useSelector((state) => (state.emissionFactorsReducer?.groupEmissionsScopeThree?.data))

    useEffect(() => {
        if (openAccordion === accordionName) {
            dispatch(getGroupEmissionsScopeThree(companyId, groupId, year))
        }
    }, [dispatch,
        openAccordion,
        companyId,
        groupId,
        year])

    return (
        <DataAccordion
            title={scopeThreeTitle}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 2 }}>
                <Typography variant='h6'>
                    Scope Three Emissions for {group} in {year}:
                </Typography>
                <DashboardEmissionsTable loading={isLoading} columns={columns} rows={scopeThreeEmissionRows} />
            </Box>
        </DataAccordion>
    )
}
